import { Project } from "../models/project.model";
import { UuidAndId } from "../models/uuid-and-id";
import { ProjectStateModel } from "../state/project.state";

export namespace ProjectActions {
    export class Refresh {
        static readonly type = '[API-PROJECT] Refresh'
        constructor() {}
    }
    export class Init {
        static readonly type = '[Storage-PROJECT] Init'
        constructor(public payload: ProjectStateModel) {}
    }
    export class Set {
        static readonly type = '[API-PROJECT] Set'
        constructor(public payload: Project[]) {}
    }
}
